export const loginStatusMapper = (data) => {
  if (!data) return null

  const userId = (data && data.profileId) ? data.profileId.toString() : ''
  const loggedIn = userId !== ''

  return {
    event: 'logged_in_check',
    userId,
    logged_in: loggedIn
  }
}
